import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { EntityType } from 'types';
import { submitCollect } from 'redux/track/actions';
import { selectTrackCounter } from 'redux/track/selectors';

interface ParamTypes {
  pageType: string;
}

const ISeekPlant: React.FC = () => {
  const dispatch = useDispatch();
  const trackCounter = useSelector(selectTrackCounter);
  const { pageType } = useParams<ParamTypes>();

  useEffect(() => {
    if (pageType) {
      dispatch(
        submitCollect({
          payload: { page: pageType },
          type: EntityType.OPEN_ISEEKPLANT_LINK
        })
      );
    }
  }, [pageType, dispatch]);

  useEffect(() => {
    if (trackCounter > 0 && pageType) {
      const qs =
        process.env.REACT_APP_ISP_ADS_WITH_UTM === 'true'
          ? `?utm_source=BYDA-integration&utm_medium=${pageType}`
          : '';
      window.location.href = `https://blog.iseekplant.com.au/byda-isp-get-quotes${qs}`;
    }
  }, [pageType, trackCounter]);

  return <></>;
};

export default ISeekPlant;
